
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.281 13.81A1.5 1.5 0 0112.75 12h3.06c1.14 0 2.178-.775 2.19-1.916V10a8 8 0 00-8-8 8 8 0 00-8 8c0 4.419 3.581 8 7.997 8 .112 0 .222-.003.331-.006.994-.04 1.669-.944 1.669-1.938 0-.453-.188-.881-.378-1.312a11.156 11.156 0 00-.022-.051c-.127-.292-.254-.582-.316-.884zm-1.097 2.41l-.187.002A6.22 6.22 0 013.777 10 6.222 6.222 0 0110 3.778 6.222 6.222 0 0116.222 10v.07a.167.167 0 01-.033.034.613.613 0 01-.38.118H12.75a3.278 3.278 0 00-3.216 3.915l.003.015.003.016c.102.493.3.947.418 1.216l.03.068.005.01c.1.229.157.362.195.48.025.075.03.11.031.118a.394.394 0 01-.035.16z","fill":"#000"}}),_c('path',{attrs:{"d":"M7.054 11.047a1.047 1.047 0 11-2.095 0 1.047 1.047 0 012.095 0zM7.859 7.27a1.047 1.047 0 11-2.095 0 1.047 1.047 0 012.095 0zM11.81 5.78a1.047 1.047 0 11-2.094 0 1.047 1.047 0 012.095 0zM14.618 7.874a1.047 1.047 0 11-2.095 0 1.047 1.047 0 012.095 0z","fill":"#000"}})])
          )
        }
      }
    